import {ChangeEvent, ChangeEventHandler, FC, RefObject, useMemo} from 'react';
import {FieldInputProps, FieldMetaProps} from 'formik';
import cx from 'classnames';

import s from './StepTextInput.module.scss';

interface IStepTextInputProps {
  autoCompleteRef?: RefObject<HTMLInputElement>;
  id: string;
  required?: boolean;
  width?: string;
  onValueChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  textAlign?: 'left' | 'center' | 'right';
  isValid?: boolean;
  field?: FieldInputProps<any>;
  meta?: FieldMetaProps<any>;
  defaultValue?: string;
  label?: string;
  placeholder?: string;
  maxLength?: number;
  fullWidth?: boolean;
  value?: string;
  name?: string;
  handleChange?: ChangeEventHandler;
}

const StepTextInput: FC<IStepTextInputProps> = ({
  autoCompleteRef,
  id,
  width,
  required,
  defaultValue,
  isValid,
  maxLength,
  fullWidth,
  field,
  meta,
  label,
  placeholder,
  value,
  handleChange,
  onValueChange,
  name,
  textAlign = 'left',
}) => {
  const responsiveInputWidth = useMemo(() => (fullWidth ? '100%' : width), [fullWidth, width]);

  return (
    <div className={cx(s.stepTextInput, {fullWidth})}>
      {label && (
        <label htmlFor={id} className={s.stepTextInput__label}>
          {label}
        </label>
      )}
      <input
        {...field}
        ref={autoCompleteRef}
        name={name}
        id={id}
        value={value}
        required={required}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onChange={(e) => onValueChange?.(e) || handleChange}
        className={cx(s.stepTextInput__item, {
          inputValid: isValid ?? (!meta?.error && (meta?.touched || field?.value)),
        })}
        style={{width: responsiveInputWidth, textAlign}}
        maxLength={maxLength}
      />
    </div>
  );
};
export default StepTextInput;
